import React from 'react';
import { pathgen } from 'object-path-generator';
import { overrideTestIds } from '../../utils/TestIds/overrideTestIds';
export const MenuItemTestIds = pathgen('MenuItemTestIds', overrideTestIds({
    MenuItemTestIds: {
        Wrapper: (testid)=>"".concat(testid, "-wrapper")
    }
}));
